import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ProfilePanel from "@components/templates/Profile/ProfilePanel/ProfilePanel";
import { panelData, portsEvent, profileTabs, profileTypeEnum } from "@components/templates/Profile/ProfileHeader/profile-enum";
import { tabDetailsHandler } from "@redux/PortProfile/portProfileSlice";
import { getEventName, getUserActivePlan, renderPortPanelData } from "@helpers/profileHelper";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import { generateTrackingObject } from "@core/global/global-country-functions";

const ProfileDetails = ({ panelList, setPanelList }) => {
  const { countDetails, tabDetails } = useSelector((state) => state.portProfile);
  const { activePanelId } = tabDetails;
  const dispatch = useDispatch();
  const { reverseRelation, loading } = countDetails;
  const { search: searchUrlParams, pathname } = useLocation();
  const profileName = new URLSearchParams(searchUrlParams).get("profileName");
  const dataSource = new URLSearchParams(searchUrlParams).get("dataSource");
  useEffect(() => {
    const activePanelTab = panelData.find((item) => item.redirectionEnum === profileName);
    if (activePanelTab) {
      dispatch(
        tabDetailsHandler({
          ...tabDetails,
          activePanelId: activePanelTab.id,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchUrlParams, profileName]);

  useEffect(() => {
    if (!panelList?.length) {
      let panelListData =
        reverseRelation === false
          ? panelData.filter((item) => {
              if (!item.redirectionEnum) {
                return item;
              } else if (item.redirectionEnum === profileName) {
                return item;
              } else if (!profileName) {
                return item;
              }
            })
          : panelData;
      setPanelList(panelListData);
    }
  }, [reverseRelation, profileName]);

  const handlePanelClick = (id, countEnum = "") => {
    trademoTrackingEvents(getEventName(profileTypeEnum.ports, portsEvent.overview[countEnum]), generateTrackingObject(dataSource, pathname, getUserActivePlan()));
    dispatch(
      tabDetailsHandler({
        ...tabDetails,
        activePanelId: id,
        activeTabId: profileTabs[0].id,
      })
    );
  };
  return panelData && panelData.length > 0 ? (
    <>
      <ProfilePanel panelData={panelList} activePanelId={activePanelId} handlePanelClick={handlePanelClick} loading={panelList?.length ? false : loading} loadingWidth={"15rem"} />
      {renderPortPanelData(activePanelId, countDetails)}
    </>
  ) : null;
};

export default ProfileDetails;
